module.exports = __webpack_public_path__ + "img/menu_user_pre.fd0a6b28.svg";